import { Fragment } from "react";
import { arrayOf, shape, string } from "prop-types";
import styled from "styled-components/macro";
import { rem } from "polished";

import { BREAKPOINT_WRAPPER } from "../../../constants";
import { colors } from "../../../styles/Styles.variables";

import FilestackAdaptive from "../../filestack-adaptive";
import PhotosPlaceholder from "../../../styles/components/PhotosPlaceholder";

const LocationTeamMembers = ({ targetDevice, team }) => {
  return (
    <Fragment>
      <h2 className="text-center">Your Used Equipment Team</h2>
      <TeamMembers>
        {team.map((member, index) => (
          <li key={`team-${index}`}>
            <TeamMemberPhoto>
              <TeamMemberPhotoContainer>
                {!!member.photo ? (
                  <TeamMemberPhotoImage
                    alt={`photo of ${member.name}`}
                    fit="crop"
                    handle={member.photo}
                    theme={targetDevice === "mobile" ? "dark" : "light"}
                    sizes={{
                      "0px": { height: 225, width: 225 },
                    }}
                  />
                ) : (
                  <TeamMemberPhotoImage as={PhotosPlaceholder} />
                )}
              </TeamMemberPhotoContainer>
            </TeamMemberPhoto>
            <p>
              <strong>{member.name}</strong>
              <br />
              {!!member.title && (
                <Fragment>
                  {member.title}
                  <br />
                </Fragment>
              )}
              {!!member.phone && (
                <a className="subtle" href={`tel:1-${member.phone}`}>
                  {member.phone}
                </a>
              )}
            </p>
          </li>
        ))}
      </TeamMembers>
    </Fragment>
  );
};

LocationTeamMembers.propTypes = {
  targetDevice: string,
  team: arrayOf(
    shape({ name: string, phone: string, photo: string, title: string })
  ).isRequired,
};

const TeamMembers = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  text-align: center;

  li {
    margin-left: auto;
    margin-right: auto;
    padding-bottom: ${rem("32px")};
    width: ${rem("225px")};
  }

  p {
    margin-bottom: 0;
  }

  strong {
    text-transform: uppercase;
  }

  @media ${BREAKPOINT_WRAPPER} {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding-bottom: ${rem("42px")};
    padding-top: ${rem("16px")};

    > li {
      margin-left: 3%;
      margin-right: 3%;
    }
  }

  @media (min-width: ${rem("1180px")}) {
    > li {
      margin-left: 6%;
      margin-right: 6%;
    }
  }
`;

const TeamMemberPhoto = styled.div`
  border-radius: ${rem("10px")};
  overflow: hidden;
  height: ${rem("225px")};
  margin-bottom: ${rem("16px")};
  width: ${rem("225px")};

  @media ${BREAKPOINT_WRAPPER} {
    margin-bottom: ${rem("30px")};
  }
`;

const TeamMemberPhotoContainer = styled.div`
  background-color: ${colors.gray200};
  height: 0;
  overflow: hidden;
  padding-top: 100%;
  position: relative;
`;

const TeamMemberPhotoImage = styled(FilestackAdaptive)`
  bottom: 0;
  display: block;
  left: 0;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  overflow: hidden;
  position: absolute;
  right: 0%;
  top: 0;
  width: 100%;

  img {
    bottom: 0;
    display: block;
    height: 100%;
    left: 0;
    position: absolute;
    right: 0%;
    top: 0;
    width: 100%;
  }
`;

export default LocationTeamMembers;
